import { connect } from 'react-redux'

import Actions from '../../Actions/Creators'
import HSGMessages from './Component/HSGMessage'
import Phi from '../../Phi/Phi'
import Constants from '../../Phi/Constants'
import { stat } from 'fs'

const mapStateToProps = (state, ownProps) =>{
  
  const userRole = Phi.User.roles();
  const userProfile = Phi.User.profile();

  const currentUserRoleId = userRole && userRole.length && userRole[0].role_type_id
  const currentUserId = userProfile && userProfile.user_id

  const chats = state.message.chats
  const messages = state.message.messages 

  return {

    currentUserRoleId,
    currentUserId,

    messageFrom: state.message.messageFrom,
    messageTo: state.message.messageTo,
    messageRef: state.message.messageRef,

    currentMessageLimit: state.message.messageLimit,
    currentMessageOffset: state.message.messageOffset,

    currentChatLimit: state.message.chatLimit,
    currentChatOffset: state.message.chatOffset,

    chats: chats,
    messages: messages,

  }
}

const mapDispatchToProps = (dispatch) => ({

  sendMessage: (inFromUser, inToUser, inRefUser, inMessage, inType) => dispatch(Actions.sendMessage(inFromUser, inToUser, inRefUser, inMessage, inType)),
  fetchMessages: (inFromUser, inToUser, inRefUser, inLimit, inOffset) => dispatch(Actions.fetchMessages(inFromUser, inToUser, inRefUser, inLimit, inOffset)),
  fetchChats: (inFromUser, inLimit, inOffset) => dispatch(Actions.fetchMessageFrom(inFromUser, inLimit, inOffset)),
  fetchMessageReceivers: (inFromUser, inLimit, inOffset) => dispatch(Actions.fetchMessageReceivers(inFromUser, inLimit, inOffset)),

});

export default connect(mapStateToProps, mapDispatchToProps)(HSGMessages)



// WEBPACK FOOTER //
// ./src/Containers/MessageContainer/index.js